export const rodzaje = [
    {
        id: 1,
        title: 'Leasing operacyjny',
        text: 'Ta forma finansowania pozwala odliczyć raty leasingowe od kosztu uzyskania przychodu przedsiębiorcy. Amortyzacja przedmiotu leasingu leży po stronie finansującego. Z reguły czas trwania umowy leasingu operacyjnego jest krótszy niż normatywne cykl eksploatacji przedmiotu umowy, a także krótszy niż standardowy okres amortyzacji.',
    },
    {
        id: 2,
        title: 'Leasing finansowy',
        text: 'zwany także kapitałowym. W tym wypadku kwestie podatkowe uregulowane są podobnie jak w przypadku kredytu. Przedmiot kontaktu stanowi własność finansującego, ale nie podlega u niego amortyzacji. Leasingobiorca zaś użytkuje przedmiot za cenę rat miesięcznych. Po okresie podstawowym umowy następuje przewłaszczenie, na warunkach wcześniej ustalonych. Korzystający opłaca miesięczne noty obciążeniowe, gdzie tylko część odsetka stanowi koszt uzyskania przychodu. Istotny jest natomiast fakt, że podatek VAT opłacany jest jednorazowo z góry całości za cały okres umowy.',
    },
    {
        id: 3,
        title: 'Leasing zwrotny',
        text: 'który następuje, gdy firma oddaje własny środek trwały firmie leasingowej, która go kupuje i oddaje w użytkowanie sprzedającemu. Dzięki temu przedsiębiorca otrzymuje zastrzyk gotówki i spłaca raty leasingowe zgodnie z przyjętym harmonogramem.',
    },
]

export const zalety = [
    {
        id: 1, 
        text: 'Większość przedsiębiorców użytkuje pojazdy w sposób mieszany. Korzystają  z nich w firmie oraz prywatnie.',
    },
    {
        id: 2, 
        text: 'Zakup nowego pojazdu lub innego przedmiotu to zazwyczaj spory wydatek dla przedsiębiorstwa. Natomiast wybór oferty leasingowej pozwala na niewielkie zaangażowanie własnego kapitału. Dzięki temu unikamy ryzyka związanego z utratą płynności finansowej firmy. ',
    },
    {
        id: 3, 
        text: 'W przypadku wykorzystania przedmiotu leasingowanego wyłącznie do celów prowadzenia działalności odliczamy 100% podatku. Taki pojazd należy zgłosić w urzędzie skarbowym oraz ewidencjonować przebieg kilometrów.',
    },
]

export const dlaczego = [
    {
        id: 1, 
        text: 'Najlepsze rozwiązanie podatkowe – doradzimy, które rozwiązanie będzie najlepsze pod kątem formy opodatkowania Klienta',
    },
    {
        id: 2, 
        text: 'Najlepsza oferta  - działamy w ramach wszystkich dostępnych firm leasingowych na rynku polskim.',
    },
    {
        id: 3, 
        text: 'Dostępność towaru – to obecnie bardzo ważny aspekt - współpracujemy z dilerami samochodowymi, dostawcami maszyn  w całej Polsce. Jesteśmy skuteczni w działaniu. Znajdziemy produkt, którego poszukujesz.',
    },
]